<script>
  import { onMount } from "svelte";

  import NavFilterRow from "./Common/NavFilterRow.svelte";
  import NavMemberRow from "./Common/NavMemberRow.svelte";
  import ActiveColumns from "./Common/ActiveColumns.svelte";
  import Filter from "../Filter/Filter.svelte";
  import AddContact from "../Popups/AddContact.svelte";
  import AddMember from "../Popups/AddMember.svelte";
  import LinkPicker from "../Common/LinkPicker.svelte";
  import Table from "../Table/Table.svelte";
  import { fixedFilters } from "../Filter/static";
  import {getProperty, deepClone, ignore} from "../Common/tools";
  import {External, M} from "../external";

  let loading = false;
  let filters = [],
    segments = [];
  let activeMemberGroup = null,
    activeColumns = null,
    activeSegment = null;
  let memberColumns = [],
    crmColumns = [];
  let order = null,
    orderDirection = null;
  let allItems = null,
    allPages = null,
    currentPage = null;
  let memberGroupsListUI = [];
  let selection = null;
  let activeFilterName = "";
  let count = "-";
  let rows = [];
  let filterInstance;
  let showGroupSettings = false;

  function load(page) {
    if (loading) {
      return;
    }
    loading = true;
    let activeFilter;

    if (page === 0) {
      activeFilter = refreshActiveFilter();
    }

    let filter = deepClone(filters[0] || []);
    if (filter.length > 0) {
      let prop = getProperty(filter, "type", External.CRM_FILTER_TYPE.SUBSCRIBER_LIST);
      if (prop != null) {
        prop.value = "_simvoly_contacts";
      }
    }

    External.Tools.makeWebsiteRequest({
      action: "listContacts",
      method: "post",
      data: {
        filter: JSON.stringify(filter),
        order: order,
        page: page,
        orderDirection: orderDirection,
        segmentId: activeSegment ? activeSegment.id : null,
        columns: JSON.stringify(activeColumns)
      },
      onOk: function (result) {
        let data = result.data;
        loading = false;

        currentPage = page;
        allPages = data.pagesCount;
        allItems = data.count;

        if (page === 0) {
          rows = data.items;

          if (activeMemberGroup) count = allItems + " " + (allItems === 1 ? M.MEMBER : M.MEMBERS);
          else count = allItems + " " + (allItems === 1 ? M.CONTACT : M.CONTACTS);

          if (activeSegment) activeSegment.count = allItems;
        } else {
          rows = rows.concat(data.items);
        }
      }
    });
    saveSearchToUrl();
  }

  function getPropertyByFilter(filter) {
    if (filter.type === External.CRM_FILTER_TYPE.PROPERTY) return External.getById(External.Website.crmProperties, filter.id);

    for (let idx = 0; idx < fixedFilters.length; ++idx) {
      if (fixedFilters[idx].fType === filter.type) return fixedFilters[idx];
    }

    return null;
  }

  function getSegmentName(segment) {
    if (segment.name) return segment.name;
    switch (segment.id) {
      case "cr7":
        return M.CREATED_LAST_7DAYS;
      case "cr30":
        return M.CREATED_LAST_30DAYS;
    }
    return "";
  }

  function setActiveFilterName(name) {
    activeFilterName = External.Tools.escapeIfNeeded(name);
  }

  function refreshActiveFilter() {
    let activeFilter = null,
      activeFilterName = null;
    activeMemberGroup = null;
    activeColumns = null;
    activeSegment = null;
    let filter;

    if (filters.length === 0) {
      activeFilter = "all";
      activeFilterName = M.ALL_CONTACTS;
    } else {
      for (let idx = 0; idx < segments.length; idx++) {
        let segment = segments[idx];
        if (segment.id === "all") {
          continue;
        }
        if (segment.filters.length === filters.length) {
          let filtersAreEqual = true;
          for (let i = 0; i < segment.filters.length; ++i) {
            let segmentFilter = segment.filters[i];
            filter = filters[i];

            if (
              segmentFilter.type !== filter.type ||
              segmentFilter.func !== filter.func ||
              segmentFilter.id !== filter.id ||
              getPropertyByFilter(segmentFilter) !== getPropertyByFilter(filter) ||
              // or values are different
              !(segmentFilter.value ? segmentFilter.value === filter.value : !segmentFilter.value === !filter.value)
            ) {
              filtersAreEqual = false;
              break;
            }
          }
          if (filtersAreEqual) {
            activeSegment = segment;
            break;
          }
        }
      }
      if (activeSegment !== null) {
        activeFilter = activeSegment.id;
        activeFilterName = getSegmentName(activeSegment);
      } else if (filters.length === 1) {
        if (filter.type === External.CRM_FILTER_TYPE.SIGNED_UP && filter.func === "any") {
          activeFilter = "members-0";
          activeFilterName = M.ALL_MEMBERS;
          activeMemberGroup = {
            id: 0,
            name: M.ALL_MEMBERS
          };
        } else if (filter.type === External.CRM_FILTER_TYPE.MEMBER_GROUP && filter.func === "is") {
          activeMemberGroup = External.Website.getMemberGroupById(filter.id);
          activeFilter = "members-" + filter.id;
          activeFilterName = activeMemberGroup ? activeMemberGroup.name : filter.value || "-";
        }
      }
    }

    activeColumns = activeMemberGroup ? memberColumns : crmColumns;

    if (activeFilter) {
      setActiveFilterName(activeFilterName);

      return {
        title: activeFilterName,
        menuItem: ""
      };
    } else {
      return null;
    }
  }

  onMount(function () {
    External.Tools.makeWebsiteRequest({
      action: "listSegments",
      onOk: function (result) {
        segments = result.data || [];
        segments.unshift({ name: M.ALL_CONTACTS, active: true, id: "all" });

        crmColumns = External.WebPlatform.getObjectFromLocalStorage("crmcolumns", []);
        if (crmColumns.length === 0) crmColumns = [-1, -2, -3, "tags", "created"];
        memberColumns = External.WebPlatform.getObjectFromLocalStorage("membercolumns", []);
        if (memberColumns.length === 0) memberColumns = [-1, -2, -3, "tags", "registered", "status"];

        restoreSegment();
        filterInstance.onFilterChanged();
        load(0);

        memberGroupsListUI = Object.assign([], External.Website.memberGroups || [], []);
        memberGroupsListUI.unshift({ name: M.ALL_MEMBERS, active: false, id: 0 });
      },
      always: function () {
        // self.ready();
        // CPanel.showHelperVideoForPage('crm');
      }
    });
  });

  function showNextPage(table) {
    if (table.hasClass("loading")) return;

    if (allItems === null || currentPage + 1 >= allPages) return;
    load(currentPage + 1);
  }

  function getSelectedItemsCount() {
    if (selection !== null) {
      if (selection.all) return allItems - selection.unselected.length;
      else return selection.selected.length;
    }
    return allItems;
  }

  function showMoreOptions(event) {
    let items = [
      {
        icon: "fa-upload",
        label: M.IMPORT,
        tag: "import"
      },
      {
        icon: "fa-download",
        label: M.EXPORT,
        tag: "export"
      },
      {
        icon: "fa-trash",
        label: M.DELETE,
        tag: "delete"
      }
    ];

    External.Tools.showFloatingPopupList({
      target: External.$(event.target).closest("a"),
      items: items,
      onSelect: function (selected) {
        if (selected.tag === "export") {
          let itemsToExport = getSelectedItemsCount();
          let message = External.escapeFormat(M.EXPORT_COUNT, "count", itemsToExport);
          External.Tools.prompt(
            M.EXPORT + " " + itemsToExport + " " + (allItems === 1 ? M.CONTACT : M.CONTACTS),
            message,
            function () {
              let params = {
                filter: filters,
                selection: selection
              };
              External.CPanel.initiateExport("EXPORT_CONTACTS", params, M.CONTACTS_EXPORT_IN_PROGRESS);
            },
            ignore,
            M.YES,
            M.NO
          );
        } else if (selected.tag === "delete") {
          let itemsToDelete = getSelectedItemsCount();
          let message = External.escapeFormat(M.DELETE_CONTACTS, "count", itemsToDelete);
          External.Tools.prompt(
            M.DELETE + " " + itemsToDelete + " " + (allItems === 1 ? M.CONTACT : M.CONTACTS),
            message,
            function () {
              External.Tools.makeWebsiteRequest({
                action: "deleteContacts",
                method: "post",
                data: {
                  filter: JSON.stringify(filters),
                  selection: JSON.stringify(selection)
                },
                onOk: function () {
                  load(0);
                }
              });
            },
            ignore,
            M.YES,
            M.NO
          );
        } else if (selected.tag === "import") {
          External.CSVContactsImporter().start();
        }
      }
    });
  }

  function showColumnOptions(event) {
    let activeColumns = activeMemberGroup ? memberColumns : crmColumns;
    let columnItems = [];
    External.Website.crmProperties.forEach(function (property) {
      columnItems.push({
        id: property.id,
        label: property.label,
        disabled: property.id === -1, // name
        checked: activeColumns.indexOf(property.id) > -1
      });
    });

    columnItems.push({
      id: "tags",
      label: M.TAGS,
      checked: activeColumns.indexOf("tags") > -1
    });

    columnItems.push({
      id: "created",
      label: M.CREATED,
      checked: activeColumns.indexOf("created") > -1
    });

    if (activeMemberGroup) {
      columnItems.push({
        id: "registered",
        label: M.REGISTERED_ON,
        checked: activeColumns.indexOf("registered") > -1
      });

      columnItems.push({
        id: "status",
        label: M.STATUS,
        checked: activeColumns.indexOf("status") > -1
      });
    }

    let component;

    External.Tools.showFloatingPopup({
      markup: '<div class="col20 f-left bound-popup"></div>',
      width: 250,
      target: External.$(event.target).closest("a"),
      customClass: "crm-filter-value",
      action: {
        onShow: function (popup, ui) {
          component = new ActiveColumns({
            target: ui.find(".bound-popup")[0],
            props: {
              data: columnItems,
              change: function () {
                let newColumns = [];
                columnItems.forEach(function (column) {
                  if (column.checked) newColumns.push(column.id);
                });
                if (newColumns.indexOf(-1) < 0) newColumns.unshift(-1);
                if (activeMemberGroup) {
                  memberColumns = newColumns;
                  External.WebPlatform.setObjectToLocalStorage("membercolumns", memberColumns);
                } else {
                  crmColumns = newColumns;
                  External.WebPlatform.setObjectToLocalStorage("crmcolumns", crmColumns);
                }
                filterInstance.onFilterChanged();
                load(0); //todo
                External.Tools.delay(200, function () {
                  External.$(document).resize();
                });
              }
            }
          });
        },
        onHide: function () {
          if (component) {
            component.$destroy();
          }
        }
      }
    });
  }

  function tagItems(event) {
    let items = [];
    External.Website.crmTags.forEach(function (tag) {
      items.push({
        id: tag.id,
        label: tag.label,
        icon: "fa-tag"
      });
    });
    items.push({
      label: M.ADD_NEW_TAG,
      icon: "fa-plus",
      id: -1
    });
    External.Tools.showFloatingPopupList({
      target: External.$(event.target).closest("a"),
      items: items,
      onSelect: function (selected) {
        if (selected.id === -1) {
          External.CPanel.goToUrl("/me/crm/settings?show=tags");
          return;
        }
        let itemsToTag = getSelectedItemsCount();
        let message = External.escapeFormat(M.ADD_TAG_CONTACTS, "label", selected.label, "count", itemsToTag);
        External.Tools.prompt(
          M.TAG + " " + itemsToTag + " " + (allItems === 1 ? M.CONTACT : M.CONTACTS),
          message,
          function () {
            External.Tools.makeWebsiteRequest({
              action: "addTag",
              method: "post",
              data: {
                tag: selected.id,
                filter: JSON.stringify(filters),
                selection: JSON.stringify(selection)
              },
              onOk: function () {
                load(0);
              }
            });
          },
          ignore,
          M.YES,
          M.NO
        );
      }
    });
  }

  function showSegment(segment) {
    for (let i = 0; i < memberGroupsListUI.length; i++) {
      memberGroupsListUI[i].active = false;
    }
    for (let i = 0; i < segments.length; i++) {
      segments[i].active = segments[i] === segment;
    }

    let id = segment.id;
    if (id === "all") filters = [];
    else {
      filters = segment.filters; // deep copy the array
    }

    filterInstance.onFilterChanged();
    load(0);
  }

  function showMemberGroup(group) {
    for (let i = 0; i < segments.length; i++) {
      segments[i].active = false;
    }
    for (let i = 0; i < memberGroupsListUI.length; i++) {
      memberGroupsListUI[i].active = memberGroupsListUI[i] === group;
    }

    let id = group.id;

    if (id === 0) {
      filters = [
        {
          func: "any",
          type: External.CRM_FILTER_TYPE.SIGNED_UP,
          id: 0,
          value: 0
        }
      ];
    } else {
      let group = External.getById(External.Website.memberGroups, id);
      filters = [
        {
          func: "is",
          type: External.CRM_FILTER_TYPE.MEMBER_GROUP,
          id: id,
          value: group.name
        }
      ];
    }
    filterInstance.onFilterChanged();
    load(0);
  }

  function addMemberGroup() {
    External.Tools.promptForInput(
      M.ADD_MEMBER_GROUP_TITLE,
      M.ADD_MEMBER_GROUP_MESSAGE,
      "",
      function (group) {
        return addNewGroup(group);
      },
      ignore,
      400
    );
  }

  function addNewGroup(newName) {
    if (newName.trim() === "") {
      External.Tools.showError(M.ERR_EMPTY_NAME);
      return false;
    }
    External.Tools.makeWebsiteRequest({
      action: "saveMembersGroup",
      data: {
        id: -1,
        name: newName,
        link: ""
      },
      onOk: function (result) {
        newName = result.data.name;

        let group = {
          id: result.data.id,
          name: newName,
          link: ""
        };

        External.Website.addMemberGroup(group);
        memberGroupsListUI.push(group);
        memberGroupsListUI = Object.assign([], memberGroupsListUI, []);
      }
    });
    return true;
  }

  function createContact() {
    let component;
    External.Tools.showWindow({
      title: M.ADD_CONTACT_TITLE,
      icon: External.Popup.ICON_EDIT,
      width: 450,
      customClass: "add-member-dialog",
      isModal: true,
      markup: '<div class="popup-newpage-wrapper bind-component"></div>',
      action: {
        onShow: function (popup, context) {
          component = new AddContact({
            target: context.find(".bind-component")[0]
          });
        },
        onHide: function () {
          if (component) {
            component.$destroy();
            component = null;
          }
        }
      },
      buttons: [
        External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup) {
          let data = component.get();

          External.Tools.makeWebsiteRequest({
            action: "createContact",
            data: {
              name: data.name,
              email: data.email
            },
            onOk: function () {
              popup.close();
              load(0);
            }
          });
        }),
        External.Button.MIDDLE_CANCEL
      ]
    });
  }

  function createMember() {
    let component;
    External.Tools.showWindow({
      title: M.ADD_MEMBER_TITLE,
      icon: External.Popup.ICON_EDIT,
      width: 450,
      customClass: "add-member-dialog",
      isModal: true,
      markup: '<div class="popup-newpage-wrapper bind-component"></div>',
      action: {
        onShow: function (popup, context) {
          component = new AddMember({
            target: context.find(".bind-component")[0]
          });
        },
        onHide: function () {
          if (component) {
            component.$destroy();
            component = null;
          }
        }
      },
      buttons: [
        External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup) {
          let data = component.get();

          if (data.memberGroups.length === 0) {
            External.Tools.showError(M.ERR_SELECT_MEMBER_GROUPS);
            return;
          }

          External.Tools.makeWebsiteRequest({
            action: "createMember",
            data: {
              name: data.name,
              email: data.email,
              groups: data.memberGroups.join(",")
            },
            onOk: function () {
              popup.close();
              load(0);
            }
          });
        }),
        External.Button.MIDDLE_CANCEL
      ]
    });
  }

  function toggleGroupSettings() {
    showGroupSettings = !showGroupSettings;
  }

  function onSelectRedirect(result) {
    if (!activeMemberGroup) return;

    saveMemberGroup(activeMemberGroup.name, result.link);
  }

  function saveMemberGroup(newName, link) {
    if (newName.trim() === "" || !activeMemberGroup) {
      External.Tools.showError(M.ERR_EMPTY_NAME);
      return false;
    }
    External.Tools.makeWebsiteRequest({
      action: "saveMembersGroup",
      data: {
        id: activeMemberGroup.id,
        name: newName,
        link: link
      },
      onOk: function (result) {
        let cachedGroup = External.Website.getMemberGroupById(activeMemberGroup.id);
        if (cachedGroup !== null) {
          cachedGroup.name = newName;
          cachedGroup.link = link;
          setActiveFilterName(activeMemberGroup.name);
          memberGroupsListUI = Object.assign([], memberGroupsListUI, []);
        }
      }
    });
    return true;
  }

  function editGroupSettings() {
    if (!activeMemberGroup) return;
    External.Tools.promptForInput(
      M.EDIT_MEMBER_GROUP_TITLE,
      M.ADD_MEMBER_GROUP_MESSAGE,
      activeMemberGroup.name,
      function (groupName) {
        return saveMemberGroup(groupName, activeMemberGroup.link);
      },
      ignore,
      400,
      false,
      false,
      []
    );
  }

  function deleteGroup() {
    External.Tools.prompt(M.DEL_CONFIRM, M.DEL_MEMBER_GROUP_MESSAGE, function () {
      if (!activeMemberGroup) return;
      External.Tools.makeWebsiteRequest({
        action: "deleteMembersGroup",
        data: {
          id: activeMemberGroup.id
        },
        onOk: function () {
          showGroupSettings = false;
          External.Website.removeMemberGroupById(activeMemberGroup.id);
          filters = [
            {
              func: "any",
              type: External.CRM_FILTER_TYPE.SIGNED_UP,
              id: 0,
              value: 0
            }
          ];
          memberGroupsListUI = memberGroupsListUI.filter(function (group) {
            return group.id !== activeMemberGroup.id;
          });
          load(0);
        }
      });
    });
  }

  function onFilterUpdate() {
    load(0);
  }

  function onSaveSegment() {
    External.Tools.promptForInput(M.NEW_SEGMENT_TITLE, M.ENTER_SEGMENT_NAME, "", function (name) {
      if (name.trim() === "") {
        External.Tools.showError(M.ERR_EMPTY_NAME);
        return;
      }
      External.Tools.makeWebsiteRequest({
        action: "saveSegment",
        method: "post",
        data: {
          name: name,
          count: allItems,
          filter: JSON.stringify(filters)
        },
        onOk: function (result) {
          segments.push(result.data);
          segments = Object.assign([], segments, []);
        }
      });
    });
  }

  function onOrder(event) {
    if (event === null) {
      order = "id";
      orderDirection = "desc";
    } else {
      if (event.dir === "asc") orderDirection = "desc";
      else orderDirection = "asc";
      order = event.column;
    }

    load(0);
  }

  let fromUrlHash = function (hash) {
    let replaceChars = {
      ".": "+",
      _: "/",
      "-": "="
    };

    hash = hash.replace(/[\._-]/g, function (match) {
      return replaceChars[match];
    });

    let data = decodeURIComponent(atob(hash));
    return JSON.parse(data);
  };

  let toUrlHash = function (data) {
    let base64 = btoa(encodeURIComponent(data));
    let replaceChars = {
      "+": ".",
      "/": "_",
      "=": "-"
    };
    base64 = base64.replace(/[\+\/=]/g, function (match) {
      return replaceChars[match];
    });
    return base64;
  };

  let saveSearchToUrl = function () {
    let currentSegment = External.WebPlatform.getUrlQueryParameter(window.location.href, "active") || "";
    let segmentData = "";

    if (activeSegment) {
      segmentData = "p:" + activeSegment.id;
    } else if (filters.length > 0) {
      segmentData = toUrlHash(
        JSON.stringify({
          filters: filters,
          order: order,
          orderDirection: orderDirection
        })
      );
    }

    if (segmentData !== currentSegment) {
      let url = External.CPanel.currentPage + (segmentData ? "?active=" + segmentData : "");
      window.history.pushState({ path: url }, "", url);
    }
  };

  let restoreSegment = function () {
    try {
      let segmentData = null;
      let currentSegment = External.WebPlatform.getUrlQueryParameter(window.location.href, "active") || "";
      if (currentSegment) {
        if (currentSegment.startsWith("p:")) {
          let segmentId = currentSegment.substr(2);
          let segment = External.getById(segments, segmentId);
          if (segment) {
            filters = Object.assign([], segment.filters, []); // deep copy the array

            segments.forEach(function (seg) {
              seg.active = seg === segment;
            });
          }
        } else {
          segmentData = fromUrlHash(currentSegment);
          if (segmentData) {
            filters = segmentData.filters || [];
            order = segmentData.order || "id";
            orderDirection = segmentData.orderDirection || "asc";
          }
        }
      } else if (filters.length > 0) {
        filters = segmentData ? segmentData.filters || [] : [];
      }
    } catch (ex) {
      External.Log.error(ex);
    }
  };

  let onURLChange = function () {
    restoreSegment();
    filterInstance.onFilterChanged();
  };
</script>

<div class="full-size flex flex-row-col-responsive">
  <div class="filter-nav members-subnav flex-none crm-filters no-selection" data-subnav="crm">
    <h3>
      {M.CONTACTS}
    </h3>
    <div class="collapse-submenu-title">
      {M.SEGMENTS}
    </div>
    <ul data-role="segments">
      {#each segments as segment (segment)}
        <NavFilterRow bind:data={segment} click={showSegment} />
      {/each}
    </ul>
    <ul>
      <li>
        <div class="collapse-submenu-title mt-15">
          {M.MEMBERS}
          <a rel="action" data-action="editMembersSettings" class="blue-text">
            {M.SETTINGS}
          </a>
        </div>
        <ul data-role="member-categories-list">
          {#if memberGroupsListUI}
            {#each memberGroupsListUI as member (member)}
              <NavMemberRow bind:data={member} click={showMemberGroup} />
            {/each}
          {/if}
        </ul>
        <a rel="action" data-action="addMemberGroup" on:click={addMemberGroup}>
          {M.ADD_GROUP}
        </a>
      </li>
    </ul>
  </div>

  <div class="desktop-hidden col20 f-left mt-15 mb-15 t-center">
    <a rel="action" data-action="toggleFilter" class="ta-center no-selection">
      {M.SHOW_FILTERS}
    </a>
  </div>

  <div class="account-settings overflow store-products flex-1 horizontal-flex-table" style="font-family: 'Roboto';">
    <div class="top-background-wrapper wide-top-background" style="padding-top:20px;">
      <div class="top-background filter-wrapper-outer">
        <div class="col20 f-left mb-5">
          <Filter bind:filters onChange={onFilterUpdate} bind:this={filterInstance} onSaveSegment={onSaveSegment} />
        </div>
      </div>
      <div class="top-background">
        <div class="text-wrapper f-left col20">
          <div class="flex-centered f-left">
            <h2 class="crm-title f-left" data-role="activeFilterName">{activeFilterName} <i class="fa fa-circle" /></h2>
            <h2 class="crm-title f-left" data-role="count">{count}</h2>
            <a rel="action" data-action="tagItems" class="crm-option" style="margin-left: 15px;" on:click={tagItems}>
              <i class="fa fa-tag" />
              {M.TAG}
            </a>
            <a rel="action" data-action="showMoreOptions" class="crm-option" style="margin-left: 10px; padding-right: 33px;" on:click={showMoreOptions}>
              {M.MORE}
              <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
                <path d="M4 6l4 4 4-4H4z" />
              </svg>
            </a>
          </div>
          <div class="f-right flex-centered">
            <a rel="action" data-action="showColumnOptions" class="crm-option" style="margin-left: 10px; padding-right: 33px;" on:click={showColumnOptions}>
              {M.COLUMNS}
              <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
                <path d="M4 6l4 4 4-4H4z" />
              </svg>
            </a>
          </div>
          <a
            rel="action"
            class="f-right middle-button blue with-icon-small"
            style="height:39px; line-height:39px;"
            data-action="createContact"
            on:click={createContact}
            class:none={activeMemberGroup != null}>
            {M.ADD_CONTACTS}
          </a>
          <a
            rel="action"
            class="f-right middle-button blue with-icon-small"
            class:none={activeMemberGroup == null}
            on:click={createMember}
            style="height:39px; line-height:39px;"
            data-action="createMember">
            {M.ADD_MEMBERS}
          </a>
          <div class="col20 f-left " data-role="group-settings">
            <div class="col20 f-left" class:none={!activeMemberGroup}>
              <a rel="action" data-action="toggleGroupSettings" class="blue-text" on:click={toggleGroupSettings}>
                {M.SHOW_GROUP_SETTINGS}
              </a>
            </div>
            <div class="col20 f-left" class:none={!activeMemberGroup || !showGroupSettings} data-role="settings-content">
              <div class="col20 f-left mt-25 flex-centered group-settings" style="flex-direction: column; align-items: start;">
                <label>
                  <h4>
                    {M.REDIRECT_PAGE}
                  </h4>
                  <span class="mb-5" style="text-align: left; font-size: 13px; width: 100%; margin-top: 3px;">{M.REDIRECT_PAGE_DESC}</span>
                  <div class="popup-input-wrapper">
                    <LinkPicker config={activeMemberGroup} onComplete={onSelectRedirect} style="border-radius: 30px;" />
                  </div>
                </label>
                <a rel="action" data-action="editGroupSettings" class="blue-text mt-10" on:click={editGroupSettings}>
                  {M.CHANGE_GROUP_NAME}
                </a>
                <a rel="action" data-action="deleteGroup" class="red-text remove-group-text mt-10" on:click={deleteGroup}>
                  {M.DELETE_GROUP}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper horizontal-flex-table" style="max-width:none; width: 94%;">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer">
          <Table activeColumns={activeColumns} data={rows} bind:selection loading={loading} tableType="contacts" nextPage={showNextPage} onOrder={onOrder}>
            <div class="text-center col20 f-left" style="padding: 70px 30px; box-sizing: border-box;">
              <h4 class="col20 f-left t-center mb-15">{M.NO_CONTACTS_MESSAGE}</h4>
            </div>
          </Table>
        </div>
      </div>
    </div>
  </div>
</div>
